import axios from "axios";

export const REACT_APP_API_URL = "REACT_APP_API_URL";

export const REACT_APP_GEOSERVER_URL = "REACT_APP_GEOSERVER_URL";
export const REACT_APP_GATEWAY_URL = "REACT_APP_GATEWAY_URL";

export const REACT_APP_COCKPIT_URL = "REACT_APP_COCKPIT_URL";

export const REACT_APP_KEYCLOAK_URL = "REACT_APP_KEYCLOAK_URL";
export const REACT_APP_KEYCLOAK_REALM = "REACT_APP_KEYCLOAK_REALM";
export const REACT_APP_KEYCLOAK_CLIENT_ID = "REACT_APP_KEYCLOAK_CLIENT_ID";

export const REACT_APP_STORE = "REACT_APP_STORE";
export const REACT_APP_REMOVE_KEYCLOAK = "REACT_APP_REMOVE_KEYCLOAK";

export const REACT_APP_URL_LOGO_MENU = "REACT_APP_URL_LOGO_MENU";

export const REACT_APP_REGEX_PASSWORD = "REACT_APP_REGEX_PASSWORD";
export const REACT_APP_UNITS_VISIBLE = "REACT_APP_UNITS_VISIBLE";
export const REACT_APP_REGEX_EMAIL = "REACT_APP_REGEX_EMAIL";
export const REACT_APP_REGEX_NAME = "REACT_APP_REGEX_NAME";
export const REACT_APP_REGEX_TELEPHONE = "REACT_APP_REGEX_TELEPHONE";

export const REACT_APP_PORTAL_ADMIN_ROLE = "REACT_APP_PORTAL_ADMIN_ROLE";

export const REACT_APP_TITLE_NAME = "REACT_APP_TITLE_NAME";

export const REACT_APP_MANUAL_URL = "REACT_APP_MANUAL_URL";

export const REACT_APP_PORTAL_HIERARCHY_ROLE =
    "REACT_APP_PORTAL_HIERARCHY_ROLE";
export const REACT_APP_PORTAL_GIS_ROLE = "REACT_APP_PORTAL_GIS_ROLE";

export const REACT_APP_MAP_DEFAULT_ZOOM = "REACT_APP_MAP_DEFAULT_ZOOM";
export const REACT_APP_MAP_DEFAULT_COORD = "REACT_APP_MAP_DEFAULT_COORD";

export const REACT_APP_GISAPI_TOKEN = "REACT_APP_GISAPI_TOKEN";

export const AVAILABLE_LANGUAGES = "REACT_APP_AVAILABLE_LANGUAGES";
export const ALLOW_DEFAULT_LANGUAGE = "REACT_APP_ALLOW_DEFAULT_LANGUAGE";

export const FAVICON_LIGHT_PATH = "REACT_APP_FAVICON_LIGHT_PATH";
export const FAVICON_DARK_PATH = "REACT_APP_FAVICON_DARK_PATH";

export const REACT_APP_VERSION = "REACT_APP_VERSION";

export const REACT_APP_CREATE_USERS_ENABLED = "REACT_APP_CREATE_USERS_ENABLED";
export const REACT_APP_EDIT_USERS_ENABLED = "REACT_APP_EDIT_USERS_ENABLED";

export const REACT_APP_PORTAL_IMPLANT_ROLE = "REACT_APP_PORTAL_IMPLANT_ROLE";
export const REACT_APP_PORTAL_APPS_ADMIN = "REACT_APP_PORTAL_APPS_ADMIN";

export const REACT_APP_TENANTS = "REACT_APP_TENANTS";
export const REACT_APP_MULTITENANT_URL = "REACT_APP_MULTITENANT_URL";

declare global {
    interface Window {
        env: any;
        back_env: any;
    }
}

/**
 * Gets an environment variable value, using the right source
 * @param {String} env_variable Environment variable name
 * @return {String} Environment variable value
 */
export const getEnvVariable = (env_variable: string): string => {
    if (window) {
        if (
            window.back_env !== undefined &&
            Object.values(window.back_env).length > 0 &&
            window.back_env[env_variable]
        ) {
            return window.back_env[env_variable];
        } else if (
            window.env !== undefined &&
            Object.values(window.env).length > 0 &&
            window.env[env_variable]
        ) {
            return window.env[env_variable];
        } else {
            return process.env[env_variable] || "";
        }
    } else {
        return process.env[env_variable] || "";
    }
};

const getTenantsByUrl = async () => {
    if (getEnvVariable(REACT_APP_MULTITENANT_URL) === "SINGLE_TENANT") {
        return [
            {
                tenantName: "local",
                realm: getEnvVariable(REACT_APP_KEYCLOAK_REALM),
                originUrl: window.location.origin,
                destinationUrl: window.location.origin,
                clientId: getEnvVariable(REACT_APP_KEYCLOAK_CLIENT_ID),
                authUrl: getEnvVariable(REACT_APP_KEYCLOAK_URL),
                portalUrl: window.location.origin,
            },
        ];
    }
    try {
        const url = `${getEnvVariable(REACT_APP_MULTITENANT_URL)}`;

        const res = await axios.get(url);
        return res.data;
    } catch (error) {
        console.error(error);
    }
};
/**
 * Gets a tenant from environment variable array, based on its originUrl
 *
 * @return {Json} Current tenant
 */
export const getTenant = async () => {
    const originUrl = window.location.origin;
    const envTenant = getEnvVariable(REACT_APP_TENANTS);
    const tenants = envTenant ? JSON.parse(envTenant) : await getTenantsByUrl();

    const tenant =
        Array.isArray(tenants) &&
        tenants.find(
            (IteratedTenant) => IteratedTenant.originUrl === originUrl
        );

    if (!tenant) {
        throw new Error(`Tenant for ${originUrl} not found`);
    }

    return tenant;
};
